module.exports = __webpack_public_path__ + "static/assets/a454eb0050dfc91e15efe6a0f4253f23.png";